import React from 'react';

export const BrandLogo = ({ className = 'h-14 w-14' }: { className?: string }) => (
  <img
    src={`${process.env.PUBLIC_URL}/brand/choripan-nea-logo.png`}
    alt="Choripan Nea"
    width={64}
    height={64}
    className={`shrink-0 rounded-full bg-white object-cover ${className}`}
  />
);
